import React from "react";
import { AlignLeft, Hand, Clock, Languages } from "lucide-react";
import { SCROLL_OFFSET } from "./sections";

const CARDS = [
  {
    icon: AlignLeft,
    title: "Long-form drafting:",
    body: "Getting a first draft down is often the hardest part of writing. Speaking it out loud keeps your train of thought moving instead of breaking it every time you pause to find the right key.",
  },
  {
    icon: Hand,
    title: "Repetitive strain or wrist pain:",
    body: "Dictation gives your hands a break during heavy writing days.",
  },
  {
    icon: Clock,
    title: "Multitasking:",
    body: "Pace around, take notes on your phone, or draft while your hands are busy with something else.",
  },
  {
    icon: Languages,
    title: "Non-native English writers:",
    body: "Speaking a thought is often more natural than typing it, especially for people who think faster than they type in a second language.",
  },
];

const WhyDictateSection = () => {
  return (
    <section
      id="why-dictate"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full lg:max-w-[815.58px]"
    >
      <h2 className="font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]">
        Why Dictate in Google Docs Instead of Typing
      </h2>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        Typing has a ceiling. Most people speak at roughly 130 to 150 words per
        minute but type closer to 40. That gap adds up fast across a full day of
        drafting emails, reports, blog posts, or client notes. Voice typing in
        Google Docs lets you close that gap without changing where you already
        work.
      </p>

      <p className="mt-[25.76px] font-jakarta text-[17.71px] font-medium leading-[26.56px] tracking-[0px] text-[#0A0D16D9]">
        It also helps in situations typing makes harder:
      </p>

      {/* 4 boxes part — 25.76px top padding, 2×2 grid with 17.17px gutters */}
      <div className="pt-[25.76px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[17.17px]">
          {CARDS.map(({ icon: Icon, title, body }) => (
            <article
              key={title}
              className="rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-white p-[16px] sm:p-[21.46px]"
            >
              <span className="flex h-[42.93px] w-[42.93px] items-center justify-center rounded-[15.02px] bg-[#EBF7FE] text-[#3AB1F6]">
                <Icon className="h-[20px] w-[20px]" strokeWidth={1.8} />
              </span>

              <div className="pt-[17.17px]">
                <h3 className="font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]">
                  {title}
                </h3>
                <p className="font-jakarta text-[16.1px] font-normal leading-[26.16px] tracking-[0px] text-[#0A0D16B2]">
                  {body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDictateSection;
